import type { FetchResponse } from '@sydle/ui-api';
import { portalCustomAPI } from '.';
import type { CatalogNode } from '../models/CatalogNode';

export interface GetTreeInput {
  nodes: string[];
  applicationIdentifier: string | undefined;
  deep?: number;
  path?: string;
}

type Children = Pick<
  CatalogNode,
  '_id' | '_class' | 'identifier' | 'name' | 'displayMode' | 'active' | 'path' | 'parent'
>;

export interface GetTreeOutput {
  return?: TreeLeaf[];
  fails?: {
    parentId?: string;
    error?: any;
  }[];
}

export interface TreeLeaf {
  parentId: string;
  level: number;
  children: Children[];
}

export async function getTree(input: GetTreeInput): Promise<FetchResponse<GetTreeOutput>> {
  return await portalCustomAPI.fetch<GetTreeInput, GetTreeOutput>('getTree', input);
}
